<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['options','height','width','data'],
  methods: {
    newData: function() {
      // console.log(this.labels);
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            data: this.debute,
            fill: false,
            // backgroundColor: "rgba(255,152,111, 0.3)",
            borderColor: "rgba(236,211,116,0.6)",
            label: "Débuté"
          },
          {
            data: this.soumis,
            fill: false,
            borderColor: "rgba(24,179,88, 0.6)", // <-- supposed to be light blue
            // borderColor: "#41c6ff",
            label: "Soumis"
          },
          {
            data: this.termine,
            fill: false,
            // backgroundColor: "rgba(255,152,111, 0.3)",
            borderColor: "rgba(57,154,219,0.6)",
            label: "Terminé"
          },
        ]},
        {
          title: {
            display: true,
            fontSize: 20,
            text: 'Changements de statut des plans'
          },
          // responsive: false,
          // Can't just just `stacked: true` like the docs say
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Changements'
              }
            }]
          },
          animation: {
            duration: 750,
          },
        }
      )
    }
  },
  computed: {
    labels: function() {
      let result = [];
      for(var value of this.data) {
        result.push(value.date.substring(5, 10));
      }
      return result
    },
    // datasets
    soumis() {
      return this.data.map(x => x.soumis);
    },
    debute() {
      return this.data.map(x => x.debute);
    },
    termine() {
      return this.data.map(x => x.termine);
    },

  },
  watch: {
    data: function() {
      this.newData();
    }
  },
  mounted() {
    this.newData();
  }
}
</script>
